import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useForm } from "react-hook-form";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import { inRange, isEmpty, lowerCase, startCase } from "lodash";
import { t } from "i18next";
import { formatWithCommas, validationRules,bankType } from "../Utils/constants";
import { Form } from "react-bootstrap";
import BonusSelect from "../component/BonusSelect";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import ModalPhone from "./ModalPhone";
import { FaCircleInfo } from "react-icons/fa6";
import iconBkash from "../assets/images/bkash.png";
import iconRocket from "../assets/images/rocket.png";
import iconNagad from "../assets/images/nagad.png";
import iconEth from "../assets/images/eth.svg";
import iconBtc from "../assets/images/btc.svg";
import iconUpay from "../assets/images/upay.png";
import phonepay from "../assets/images/phonepay.png";
import googlepay from "../assets/images/googlepay.png";
import paytm from "../assets/images/paytm.png";
import bankImg from "../assets/images/bank.png";


const paymentIcons = {
  bkash: iconBkash,
  nagad: iconNagad,
  rocket: iconRocket,
  eth: iconEth,
  btc: iconBtc,
  upay: iconUpay,
  phonepay: phonepay,
  googlepay: googlepay,
  paytm: paytm,
};
const Withdraw = () => {
   const getPaymentIcon = (bankName) => {
  const name = bankName?.toLowerCase() || "";

  const key = Object.keys(paymentIcons).find((item) =>
    name.includes(item)
  );

  return key ? paymentIcons[key] : bankImg;
};
    const navigate = useNavigate();

    const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });

  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const setLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLoader;
  });
  const inputRef = useRef(null);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { bankAccount: profileData?.phone },
    mode: "onChange",
    shouldFocusError: true,
  });
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm({});
  const [verifyEdit, setVerifyEdit] = useState({});
  const handleCloseVerify = () => {
    setVerifyEdit({ status: false });
  };
  const [show, setShow] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("bkash");
  const { t } = useTranslation();
  const [id, setId] = useState("");
  const [bank, setBank] = useState([]);
  const [minWithdraw, setMinWithdraw] = useState(200);
  const [maxWithdraw, setMaxWithdraw] = useState(30000);
  const onSubmit = async (body) => {
    setLoader(true);
    let bodyObj = {
      amount: body?.amount,
      bank: id,
      AccountName: selectedMethod.toUpperCase(),
      BankAccount: body?.bankAccount,
      phone_number: body?.phone,
      pin: body?.verificationCode,
       payout:true,
    };

    const { status, data } = await apiPost(apiPath.withdrawal, bodyObj);
    if (status == 200) {
      if (data?.success) {
        toast.success(data?.message);
        amounutRefresh();
        reset();
        setLoader(false);
      } else {
        toast.error(data?.message);
        reset();
        setLoader(false);
      }
    } else {
      toast.error(data?.message);
      reset();
      setLoader(false);
    }
  };
 const numberList =
  profileData?.temporaryPhone && profileData.temporaryPhone !== 0
    ? [
        { title: profileData.temporaryPhone },
        { title: profileData.phone },
      ]
    : [{ title: profileData.phone }];

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "withdrawal",
    });
    if (status == 200) {
      if (data?.success) {
        let result = data?.results?.bankList?.map((res) => {
          return {
            ...res,
            bank_name: startCase(res?.bank_name),
            title: startCase(res?.bank_name),
          };
        });
        setBank(result);
        setSelectedMethod(result[0]?.title);
        getBankDetail(result[0]?._id);
      }
    }
  };
  const getBankDetail = async (body) => {
    setId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };
  useEffect(() => {
    getBank();
    getProfileData();
  }, []);

  useEffect(() => {
    if (!isEmpty(profileData) && profileData?.limitSetting.length > 0) {
      setMinWithdraw(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.minWithdraw,
      );
      setMaxWithdraw(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.maxWithdraw,
      );
    }
  }, [!isEmpty(profileData?.limitSetting)]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(watch("bankAccount"))
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const [isLoader1, setLoader1] = useState(false);

  const onSubmit1 = async (body) => {
    setLoader1(true);
    const { status, data } = await apiPost(apiPath.verifyOtpNew, {
      new_phone_number:
        inputRef?.current?.state.selectedCountry?.countryCode +
        body?.mobile?.substring(
          inputRef?.current?.state.selectedCountry?.countryCode?.length,
          body?.mobile?.toString()?.length,
        ),
      phone_number: profileData?.phone
        ? profileData?.phone
        : inputRef?.current?.state.selectedCountry?.countryCode +
          body?.mobile?.substring(
            inputRef?.current?.state.selectedCountry?.countryCode?.length,
            body?.mobile?.toString()?.length,
          ),
      type: "password",
      password: body?.verificationCode,
    });
    if (status === 200) {
      if (data.success) {
        setLoader1(false);
        handleCloseVerify();
        getProfileData();
        toast.success("Otp verified successfully");
        reset();
      } else {
        setLoader1(false);
        toast.error(data?.message);
      }
    } else {
      setLoader1(false);
      toast.error(data?.message);
    }
  };
  return (
    <div className="bank-detail-card deposit-card v-card v-sheet theme--light elevation-0">
      <div>
        
        <div style={{ marginTop: "10px", marginBottom: "10px",padding:`10px` }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      <span>{t("Withdrawal Amount")} </span>
                      <span>
                        BDT{" "}
                        {Math.max(
                          Math.trunc(
                            ((Number(userCoins?.balance) || 0) -
                              (Number(profileData?.availableTurnoverFinal) || 0)) * 100
                          ) / 100,
                          0
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      <span>{t("Holding Amount")} </span>
                      <span>
                        BDT{" "}
                        {Number(profileData?.availableTurnoverFinal).toFixed(
                          2,
                        ) || 0}{" "}
                      </span>
                    </div>
                  </div>

                  {/* <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                      <FaCircleInfo onClick={() => navigate('/terms')} color="blue" style={{marginRight:"5px"}}/>
                    <button onClick={() => navigate('/turnover')}
                      type="button"
                      style={{
                        padding: "3px",
                        fontSize: "13px",
                        width: "40%",
                        minHeight: "30px",
                        background: `#33df72`,
                        color: `#fff`,
                        borderRadius:`25px`
                      }}
                      data-v-69dbebc8
                      className="submit"
                    >
                      Turnover
                    </button>
                  </div> */}
        <div className="row breakpoint no-gutters align-end px-8 pt-4">
          <div className="col col-auto">
            <div className="hidden-md-and-up">
              <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                Payment Methods
              </label>
            </div>
            <div className="hidden-sm-and-down">
              <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                Deposit Options
              </label>
            </div>
            <div className="row py-2 mb-3 no-gutters" style={{ gap: "0.5rem" }}>
              {bank.map((method) => (
                <div className="col col-auto">
                  <button
                    onClick={() => {
                      setSelectedMethod(method.bank_name);
                      getBankDetail(method?._id);
                    }}
                    key={method?._id}
                    type="button"
                    className={`${
                      selectedMethod === method.bank_name
                        ? "active-gateway-button v-btn--active"
                        : ""
                    } v-btn v-btn--outlined theme--light v-size--default pa-2 gateway-button mobile-paymentMethod`}
                    style={{ height: "100%", width: "100px" }}
                  >
                    <span
                      style={{ display: "flex", flexDirection: "column" }}
                      className="v-btn__content"
                    >
                      <img
                        style={{ width: "35px", marginBottom: "5px" }}
                         src={getPaymentIcon(method?.bank_name)}
                      />
                      <span style={{ fontSize: "9px" }}>
                        {startCase(method?.bank_name)}
                      </span>
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)} className="v-form">
           
          {/* <div className="row breakpoint no-gutters align-end px-8 pt-2" style={{display:`none`}}>
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Account_Name")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              type="text"
                              {...register("accountName")}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
 <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Amount")}
                      <span className="red--text ml-1">*</span>
                    </label>
                  </div>

                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              placeholder={t("Amount")}
                              type="number"
                              {...register("amount", {
                                required: {
                                  value: true,
                                  message: t("Please_enter_amount"),
                                },
                                validate: (value) => {
                                  if (value > 0) {
                                    if (Number(value) > Number(maxWithdraw)) {
                                      return (
                                        "Amount should not be greater than " +
                                        maxWithdraw
                                      );
                                    } else if (value < Number(minWithdraw)) {
                                      return (
                                        "Minimum Amount Should be greater than " +
                                        minWithdraw
                                      );
                                    }
                                  } else {
                                    return t("Amount_0");
                                  }
                                },
                              })}
                            />
                          </div>
                        </div>
                        {errors.amount && errors.amount.message && (
                          <div className="v-text-field__details">
                            <div
                              className="v-messages theme--light error--text"
                              role="alert"
                            >
                              <div className="v-messages__wrapper">
                                <div className="v-messages__message">
                                  {errors.amount.message}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Mobile Number")}
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                        <select
                      {...register("phone", {
                        required: {
                          value: true,
                          message: "Please select number",
                        },
                      })}
                      id="depositBankId"
                      class="gatewayBankSelect"
                      onChange={(e) => {
                        setValue("bankAccount", e.target.value);
                      }}
                      style={{width:`100%`}}
                    >
                      <option value="">{t("Please select number")}</option>

                      <option value={profileData?.phone}>
                        {profileData?.phone}
                      </option>

                      {profileData?.temporaryPhone &&
                        profileData?.temporaryPhone != 0 && (
                          <option value={profileData?.temporaryPhone}>
                            {profileData?.temporaryPhone}
                          </option>
                        )}
                    </select>
                    {errors?.phone?.message && (
                      <div class="transaction-errMsg text-danger depositMsg">
                        {errors?.phone?.message}
                      </div>
                    )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div
                className="depo-box mobile"
                light
                remark="fieldHint.promotionRemark"
              >
                <div className="row no-gutters justify-space-between">
                  {/* <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      {t("Mobile_Number")}
                      <span className="red--text ml-1">*</span>
                    </label>
                  </div> */}
                  <div className="col col-2">
                    <button
                      style={{
                        height: "22px",
                        fontSize: "11px",
                        marginBottom: "5px",
                        borderRadius: "5px",
                      }}
                      type="submit"
                      onClick={() =>
                        setVerifyEdit({
                          ...verifyEdit,
                          status: true,
                          phoneStatus: "add",
                          item: profileData?.phone,
                        })
                      }
                      className={`theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default deposit-btn buttonPrimary`}
                    >
                      <span className="v-btn__content">Add</span>
                    </button>
                  </div>
                  {/* <div className="col col-12">
                    <div
                      onClick={() => setShow(true)}
                      className={`v-input input-field v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select ${
                        show
                          ? "v-input--is-focused  v-select--is-menu-active buttonPrimary--text"
                          : ""
                      }`}
                    >
                      <div className="v-input__control">
                        <div
                          role="button"
                          aria-haspopup="listbox"
                          aria-expanded="false"
                          aria-owns="list-614"
                          className="v-input__slot"
                        >
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-select__slot">
                            <div className="v-select__selections">
                              <div className="v-select__selection v-select__selection--comma">
                                {isEmpty(watch("bankAccount"))
                                  ? "No Selected"
                                  : watch("bankAccount")}
                              </div>
                            </div>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setValue("bankAccount", "");
                              }}
                              className="v-input__append-inner"
                            >
                              <div className="v-input__icon v-input__icon--clear">
                                <button
                                  type="button"
                                  aria-label="clear icon"
                                  className="v-icon notranslate v-icon--link mdi mdi-close theme--light"
                                />
                              </div>
                            </div>
                            <div className="v-input__append-inner">
                              <div className="v-input__icon v-input__icon--append">
                                <i
                                  aria-hidden="true"
                                  className="v-icon notranslate mdi mdi-menu-down theme--light"
                                />
                              </div>
                            </div>
                            <input type="hidden" />
                          </div>
                          <div className="v-menu"></div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>{" "}
         
          <div className="row breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label
                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                      style={{ float: "left" }}
                    >
                      Password
                    </label>
                  </div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                              autoComplete="new-password"
                              id="input-608"
                              type="text"
                              {...register("verificationCode", {
                                required: "Please enter password",
                              })}
                            />
                          </div>
                        </div>
                        {errors.verificationCode &&
                          errors.verificationCode.message && (
                            <div className="v-text-field__details">
                              <div
                                className="v-messages theme--light error--text"
                                role="alert"
                              >
                                <div className="v-messages__wrapper">
                                  <div className="v-messages__message">
                                    {errors.verificationCode.message}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          
          <div className="row pb-5 breakpoint no-gutters align-end px-8 pt-2">
            <div className="col-md-6 col">
              <button
                type="submit"
                className={`theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default ${
                  isMobile ? "deposit-btn buttonPrimary" : "deposit-btn-desktop"
                }`}
              >
                <span className="v-btn__content"> {t("WITHDRAW")}</span>
              </button>
            </div>
          </div>
        </Form>
      </div>{" "}
      {show && (
        <BonusSelect
          options={numberList}
          value={watch("bankAccount")}
          onChange={(e) => {
            setValue("bankAccount", e?.title);
            setValue("phone", e?.title);
          }}
          show={show}
          setShow={setShow}
        />
      )}
      {verifyEdit?.status && (
        <ModalPhone
          setShow={handleCloseVerify}
          onSubmit1={onSubmit1}
          errors1={errors1}
          verifyEdit={verifyEdit}
          handleSubmit1={handleSubmit1}
          control1={control1}
          inputRef={inputRef}
          register1={register1}
          isLoader1={isLoader1}
        />
      )}
    </div>
  );
};

export default Withdraw;
